
import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  FormControl,
  TextField,
  IconButton,
  Select,
  MenuItem,
  Modal,
  Skeleton,
} from "@mui/material";
import {
  headingStyle,
} from "../../style/LapPageStyle";
import CloseIcon from "@mui/icons-material/Close";
import {
  primaryBtn,
} from "../../style/AppointmentStyle";
import { primaryBtnTeal } from "../../style/PatientDetailsStyle";
import { showToast } from "../../utils/toastUtil";
import { autoFocusOffWithOutBorder, drTableRowBlueBg } from "../../style/PatinetFormStyle";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import CustomModal from "../CustomModal/CustomModal";
import NewMedicineSalt from "./NewMedicineSalt";
import medicine_salt from '../../assets/medicine_salt.svg'
import EditMedicineSalt from "./EditMedicineSalt";
import UseFetchMedicineSaltDetails from "../../helper/UseFetchMedicineSaltDetails";
import { deleteMedicineSalt } from "../../connections/deleteApi";
import { formattedDateWithoutBg } from "../../utils/constantFunctions";
import { useNavigate } from "react-router-dom";

const MedicineSaltDetails = ({ onClose, id, refetch, page, itemPerPage }) => {


  const { data: medicineDetails, isLoading } = UseFetchMedicineSaltDetails(id);
  // console.log(medicineDetails);

  const [filterModal, setFilterModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [detailsModal, setDetailsModal] = useState(false);
  const [editPurchaseOrderModal, setEditPurchaseOrderModal] = useState(false);
  const [newPurchaseOrderModal, setNewPurchaseOrderModal] = useState(false);

  const handleDelete = async (id) => {
    setDeleteModal(false);
    const res = await deleteMedicineSalt(id);
    console.log(res);
    showToast(res?.status?.message || res?.status?.status, res?.status?.status);
    if (res?.status?.status === 'SUCCESS') {
      refetch(page, itemPerPage);
      onClose();
    }
  }
  // console.log(medicineDetails);
  const navigate = useNavigate();

  return (
    <>
      <Box sx={{
        width: "100%", display: 'flex', height: "90vh", flexDirection: 'column',
      }}>

        {/* //modals for delete and filter */}

        <Box sx={{
          overflow: 'auto',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          '-ms-overflow-style': 'none',
          'scrollbar-width': 'none',
        }}>


          <Modal
            open={deleteModal}
            onClose={() => setDeleteModal(false)}
            sx={{
              position: 'absolute',
              top: '25%',
              // left:'50%',
              width: "450px",
              // height:"400px", 
              margin: 'auto',
              //  display: "flex",
              //  alignItems: "flex-start",
              //  justifyContent: "center",
              //  overflow: "auto",
              borderRadius: '20px',
            }}
          >

            <Box
              sx={{
                mt: 2,
                bgcolor: "background.paper",
                borderRadius: 3.6,
                boxShadow: 24,
                p: 4.5,
                "&:focus": {
                  outline: "none",
                },


              }}
            >

              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography textAlign={'center'}>Are you sure?</Typography>
                <Typography textAlign={'center'}>You want to delete these selected purchase orders?</Typography>

              </Box>

              <Box sx={{ display: 'flex', flexDirection: 'flex', gap: '25px', width: 'max-content', margin: 'auto', marginTop: "40px" }}>
                <Button onClick={() => handleDelete(id)} sx={{
                  backgroundColor: "#FF392B", color: "white", border: '', width: "150px", borderRadius: "5px", fontSize: "12px", textTransform: 'capitalize', '&:hover': {
                    backgroundColor: "red",
                  }
                }}>Delete</Button>

                <Button onClick={() => setDeleteModal(false)} sx={{ backgroundColor: "white", color: "black", border: '2px solid #FF392B', width: "150px", borderRadius: "5px", fontSize: "12px", textTransform: 'capitalize' }}>Cancel</Button>
              </Box>

            </Box>
          </Modal>

          <Modal
            open={filterModal}
            onClose={() => setFilterModal(false)}
            sx={{
              position: 'absolute',
              top: '14%',
              // left:'50%',
              width: "340px",
              // height:"400px",
              margin: 'auto',
              //  display: "flex",
              //  alignItems: "flex-start",
              //  justifyContent: "center",
              //  overflow: "auto",
              borderRadius: '20px',
            }}
          >

            <Box
              sx={{
                mt: 2,
                bgcolor: "background.paper",
                borderRadius: '20px',
                boxShadow: 24,
                p: 1,
                "&:focus": {
                  outline: "none",
                },


              }}
            >

              <Grid container spacing={2} sx={{ padding: '9px' }}>
                <Grid item xs={12}>
                  <Typography variant="subTitle116px" fontWeight={'600'} textAlign={'center'} margin={'auto'}>Filters</Typography>
                </Grid>



                {/* <Grid item xs={12}>
        <Typography  variant="subTitle116px" >Suppliers</Typography>
      </Grid> */}

                {/* Filter Selection */}
                <Grid item xs={12}>

                  <Select fullWidth defaultValue="" placeholder="Select Filter" sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensure border remains none on focus
                    },
                    "& .MuiSelect-select": {
                      padding: "9px",
                      borderRadius: "15px",
                      backgroundColor: "#F7F7FF",
                    },
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    }
                  }}

                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <span style={{ color: "text.default_grey" }}>
                            Select filter
                          </span>
                        );
                      }
                      return selected === "filter1"
                        ? "filter2"
                        : selected === "filter3"
                          ? "filter3"
                          : "select filter";
                    }}
                  >
                    <MenuItem value="filter1">Filter 1</MenuItem>
                    <MenuItem value="filter2">Filter 2</MenuItem>
                    <MenuItem value="filter3">Filter 3</MenuItem>
                  </Select>
                </Grid>

                {/* Purchase Date */}
                <Grid item xs={12}>
                  <Typography variant="subTitle116px">Purchase Date</Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    sx={autoFocusOffWithOutBorder}
                    label="From"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    sx={autoFocusOffWithOutBorder}
                    label="To"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                {/* Department Selection */}
                <Grid item xs={12}>
                  <Typography variant="subTitle116px">Department</Typography>
                  <Select fullWidth defaultValue="" sx={{
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Remove border on hover
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: "none", // Ensure border remains none on focus
                    },
                    "& .MuiSelect-select": {
                      padding: "9px",
                      borderRadius: "15px",
                      backgroundColor: "#F7F7FF",
                    },
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    }
                  }}>
                    <MenuItem value="dept1">Department 1</MenuItem>
                    <MenuItem value="dept2">Department 2</MenuItem>
                    <MenuItem value="dept3">Department 3</MenuItem>
                  </Select>
                </Grid>

                {/* Created At */}
                <Grid item xs={12}>
                  <Typography variant="subTitle116px">Created At</Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    sx={autoFocusOffWithOutBorder}
                    label="From"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    sx={autoFocusOffWithOutBorder}
                    label="To"
                    type="date"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                {/* Buttons */}
                <Grid item xs={6}>
                  <Button fullWidth variant="subTitle116px16px" sx={{ ...primaryBtnTeal, color: 'white' }}>Apply</Button>
                </Grid>
                <Grid item xs={6}>
                  <Button onClick={() => setFilterModal(false)} fullWidth variant="subTitle116px16px" sx={{ ...primaryBtn, color: 'white', border: 'none' }}>Clear Filters</Button>
                </Grid>
              </Grid>



            </Box>
          </Modal>

          <Box mb={2}>

            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              position="sticky"
            >
              <Box></Box>

              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: "5px" }} >
                <img src={medicine_salt} alt='' sx={{ color: 'neutral.navyBlue', marginBottom: "4px", marginRight: '14px' }} />
                <Typography
                  variant="heading_Large"
                  fontWeight={700}
                  gutterBottom
                  sx={{ ...headingStyle }}
                >
                  Medicine salt Details
                </Typography>
              </Box>
              <IconButton sx={{ marginBottom: "0rem" }} onClick={onClose}>
                <CloseIcon size="small" sx={{ color: "red" }} />
              </IconButton>
            </Box>

            <Box
              mt={1}
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              position="sticky"
              paddingX="25px"
            >

              <Box sx={{ display: 'flex', gap: '20px', flexDirection: 'column' }}>
                <Box sx={{ display: 'flex', gap: '34px', flexDirection: 'row', alignItems: 'center' }}>
                  <Typography fontWeight={'bold'}>
                    Name:
                  </Typography>
                  {isLoading ?
                    <Skeleton variant="text" width="60%" height={30} /> :
                    <Typography fontWeight={'600'}>
                      {medicineDetails?.payload?.name?.trim()}
                    </Typography>
                  }
                </Box>

                <Box sx={{ display: 'flex', gap: '5px', flexDirection: 'row', alignItems: 'center' }}>
                  <Typography fontWeight={'bold'}>
                    Medicines:
                  </Typography>

                  {medicineDetails?.payload?.medicines?.length === 0 && !isLoading &&

                    <Typography fontWeight={'600'}>
                      No medicines are linked with this salt
                    </Typography>
                  }
                </Box>
              </Box>

              <Box mt={-3} sx={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '10px', marginRight: '20px' }}>
                <EditOutlinedIcon onClick={() => {
                  setEditPurchaseOrderModal(true)
                  navigate("/pharmacy",
                    { state: medicineDetails?.payload })

                }} sx={{ backgroundColor: "#FF8D1E", p: '4px', width: "18px", color: 'white', borderRadius: "5px", cursor: "pointer" }} />
                <DeleteForeverOutlinedIcon onClick={() => { setDeleteModal(true) }} sx={{ backgroundColor: "#FF392B", p: '4px', width: "18px", color: "white", borderRadius: "5px", cursor: "pointer" }} />
              </Box>
            </Box>
          </Box>

          <Box
            sx={{
              // marginY: "30px",
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, // 1 col for xs/sm, 2 cols for md+
              gap: 6, // uniform gap between rows and columns
              // maxWidth: 1200,
              paddingX: "25px",
              paddingRight: '35px',
              margin: 'auto',
              // marginRight: '20px',
              // padding: '20px',
              // paddingRight: '30px',
              justifyContent: 'center',
              // alignItems: "center", // make cards align to top
              boxSizing: "border-box",
              marginBottom: '50px',
            }}
          >



            {isLoading ? (
              // 👉 Show skeletons when loading
              Array.from(new Array(2)).map((_, index) => (
                <Box
                  key={index}
                  sx={{
                    width: "98%",
                    margin: "auto",
                    borderRadius: "20px",
                    padding: "14px",
                    boxShadow:
                      "rgba(0, 0, 0, 0.1) 0px 0px 5px, rgba(0, 0, 0, 0.1) 0px 0px 1px",
                  }}
                >
                  <Skeleton variant="text" width="60%" height={30} />
                  <Skeleton variant="text" width="40%" height={24} />
                  <Box mt={2}>
                    <Skeleton variant="rectangular" width="100%" height={120} />
                  </Box>
                </Box>
              ))
            ) : (
              medicineDetails?.payload?.medicines?.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    // width: "45%",
                    // width: "100%",
                    width: "98%", // or a fixed px width like 300px
                    margin: "auto",
                    // marginTop: "24px",
                    borderRadius: "20px",
                    padding: "14px",
                    boxShadow:
                      "rgba(0, 0, 0, 0.1) 0px 0px 5px, rgba(0, 0, 0, 0.1) 0px 0px 1px",
                  }}
                >
                  <Typography mb={1.5} variant="heading1" color="#0067FF">
                    {item?.name}
                  </Typography>
                  <Typography fontSize="18px">
                    Company: {item?.company || '-'}
                  </Typography>
                  <Box
                    mt={2}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, // responsive: single column on xs, two columns on md+
                      columnGap: 4,
                      rowGap: 1.5,
                      alignItems: "start",
                    }}
                  >
                    {/* prepare two arrays of fields so the layout is predictable & easy to maintain */}
                    {(() => {
                      const leftFields = [
                        { label: "ID", value: item?.id },
                        { label: "Discount", value: item?.discount },
                        { label: "Batch", value: item?.batch },
                        { label: "MFG Date", value: item?.manufacture_date }, // format if needed
                        { label: "Expiry", value: item?.expiry_date }, // format if needed
                        { label: "Amount", value: item?.flat_price }, // format if needed
                        { label: "Purchase Cost", value: item?.purchase_cost },
                        { label: "Created at", value: formattedDateWithoutBg(item?.created_at?.split(' ')[0]) },
                      ];

                      const rightFields = [
                        { label: "Form Type", value: item?.form_type },
                        { label: "Stock Left", value: item?.stock_left },
                        { label: "Purchase at", value: item?.purchased_at },
                        { label: "Delivered at", value: item?.delivered_at },
                        { label: "GST", value: item?.gst },
                        { label: "Units Purchased", value: item?.units_purchased },
                        { label: "Auto Purchase", value: item?.auto_purchase_threshold },
                        { label: "Updated at ", value: formattedDateWithoutBg(item?.updated_at?.split(' ')[0]) },
                      ];

                      // helper renderer which produces a fixed-label column + flexible value column
                      const Column = ({ fields }) => (
                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "120px 1fr", // LABEL column fixed, VALUE flexible
                            rowGap: 1.5,
                            columnGap: 2,
                            alignItems: "center",
                          }}
                        >
                          {fields.map((f, idx) => (
                            // each pair is two grid cells: label then value
                            <React.Fragment key={idx}>
                              <Typography
                                sx={{
                                  fontWeight: 700,
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  fontSize: 14,
                                }}
                              >
                                {f.label}
                              </Typography>
                              <Typography
                                sx={{
                                  fontWeight: 400,
                                  color: "text.primary",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  fontSize: 14,
                                }}
                              >
                                {f.value ?? "-"}
                              </Typography>
                            </React.Fragment>
                          ))}
                        </Box>
                      );

                      return (
                        <>
                          <Column fields={leftFields} />
                          <Column fields={rightFields} />
                        </>
                      );
                    })()}
                  </Box>

                </Box>
              )))}
          </Box>

        </Box>

      </Box>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%" }}
        open={editPurchaseOrderModal}
        onClose={() => setEditPurchaseOrderModal(false)}
      >
        <EditMedicineSalt onClose={() => setEditPurchaseOrderModal(false)}
          refetch={refetch} />
      </CustomModal>

      <CustomModal
        customStyles={{ border: "none", minWidth: "85%" }}
        open={newPurchaseOrderModal}
        onClose={() => setNewPurchaseOrderModal(false)}
      >
        <NewMedicineSalt onClose={() => setNewPurchaseOrderModal(false)} />
      </CustomModal>


    </>
  );
};

export default MedicineSaltDetails;
